import React from 'react';


const HealthCheck = () => {

  return 'App is running';
}

export default HealthCheck